<div class="wrapper">
  <div *ngIf="!iframe" class="background-img top-right-rectangle"></div>
  <div class="wrapper-frame">
    <router-outlet></router-outlet>
  </div>
  <div *ngIf="!iframe" class="background-img bottom-left-rectangle"></div>
  <div *ngIf="!iframe" class="background-img bottom-right-rectangle"></div>
</div>
